import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import digital4 from '../../assets/image/digital/digital4.png'
import digital5 from '../../assets/image/digital/digital5.png'
import digital6 from '../../assets/image/digital/digital6.png'
import mobile_learning_image from '../../assets/image/digital-learning/mobile_learning.jpg'
export default class mobile_learning extends Component {
    render() {
        const image=[
            {image:mobile_learning_image}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Digital Learning','E-Learning Platform Implementation']} image={image} title="E-learning Platform Implementation" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                We always adapt with the latest technology-based learning methodology to keep pace with the shifting learning styles of the millennials. These changes of millennial’s learning style have become an issue for several companies that are not ready for it and we are here to help your company in facing the shifting of learning culture by adopting digital technology-based learning methods.
                                <br/><br/>
                                <img src={digital4}/>
                                <br/>
                                <img src={digital5}/>
                                <br/>
                                <img src={digital6}/>
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
